/*
import apiClient from "@/services/apiClient"
import urls from "@/web_client/urls"
import { Grupo } from "./models"

const normalizarGrupos = (grupos: Grupo[]): Grupo[] => {
  return grupos.map(g => ({
    ...g,
    blancosArray: Object.values(g.blancos || {})
  }))
}

export default {
  async fetchGrupos({ commit }: any) {
    commit("SET_LOADING", true)

    try {
      const response = await apiClient.get(urls.aisUrls.grupos)

      const data = normalizarGrupos(response.data)

      commit("SET_GRUPOS", data)

    } catch (error) {
      console.error("Error obteniendo grupos", error)
    } finally {
      commit("SET_LOADING", false)
    }
  }
}
*/
/*
import apiClient from "@/web_client/axios_config" //  CORREGIDO
import urls from "@/web_client/urls"
import { Grupo } from "./models"

const normalizarGrupos = (grupos: Grupo[]): Grupo[] => {
  return grupos.map(g => ({
    ...g,
    blancosArray: Object.values(g.blancos || {})
  }))
}

export default {
  async fetchGrupos({ commit }: any) {
    commit("SET_LOADING", true)

    try {
      const response = await apiClient.get(urls.aisUrls.grupos)

      const data = normalizarGrupos(response.data)

      commit("SET_GRUPOS", data)

    } catch (error: any) {
      console.error("Error obteniendo grupos", error?.response?.data || error.message)
    } finally {
      commit("SET_LOADING", false)
    }
  }
}

*/

import { Actions } from "vuex-smart-module"
import GruposState from "./state"
import GruposGetters from "./getters"
import GruposMutations from "./mutations"

import apiClient from "@/web_client/axios_config"
import urls from "@/web_client/urls"
import { Grupo } from "./models"

export default class GruposActions extends Actions<
  GruposState,
  GruposGetters,
  GruposMutations,
  GruposActions
> {
  // 📥 GET
  async fetchGrupos() {
    this.mutations.setLoading(true)

    try {
      const response = await apiClient.get<Grupo[]>(urls.aisUrls.grupos)

      const data = response.data.map(g => ({
        ...g,
        blancosArray: Object.values(g.blancos || {})
      }))

      this.mutations.setGrupos(data)

    } catch (error) {
      console.error("Error obteniendo grupos", error)
    } finally {
      this.mutations.setLoading(false)
    }
  }
  //

// ========================
  // ➕ CREATE
  // ========================
  async createGrupo(payload: {
    nombre: string
    informacion: string
    color: string
  }) {
    /*
    try {
      await apiClient.post(urls.aisUrls.grupos, payload)

      // 🔄 refrescar lista
      await this.actions.fetchGrupos()

    } catch (error) {
      console.error("Error creando grupo", error)
    }
    */

    try {
      const body = {
        ...payload,
        fecha: new Date().toISOString(), // 🕒 fecha actual
        blancos: {} // 📦 inicial vacío
      }

      await apiClient.post(urls.aisUrls.grupos, body)

      await this.actions.fetchGrupos()

    } catch (error) {
      console.error("Error creando grupo", error)
    }

  }

  // ========================
  // ✏️ UPDATE
  // ========================
  /*
  async updateGrupo(payload: {
    id: number
    nombre: string
    informacion: string
    color: string
  }) {

    try {
      await apiClient.put(`${urls.aisUrls.grupos}${payload.id}`, payload)

      // 🔄 refrescar lista
      await this.actions.fetchGrupos()

    } catch (error) {
      console.error("Error actualizando grupo", error)
    }
  }
  */
 async updateGrupo(payload: {
  id: number
  nombre: string
  informacion: string
  color: string
  blancos: Record<number, any>
}) {
  try {

    // 🔎 buscar grupo actual en el estado
    const grupoActual = this.state.grupos.find(g => g.id === payload.id)


    if (!grupoActual) {
      throw new Error("Grupo no encontrado en store")
    }

    const body = {
      id:payload.id,
      nombre: payload.nombre,
      informacion: payload.informacion,
      color: payload.color,
      fecha: new Date().toISOString(),

      // 🔥 clave: preservar blancos
      blancos: payload.blancos || {}
    }

    await apiClient.put(
      `${urls.aisUrls.grupos}${payload.id}`,
      body
    )

    await this.actions.fetchGrupos()

  } catch (error) {
    console.error("Error actualizando grupo", error)
  }
}
  // ========================
  // ❌ DELETE
  // ========================
  async deleteGrupo(id: number) {

    try {
      await apiClient.delete(`${urls.aisUrls.grupos}${id}`)

      // 🔄 refrescar lista
      await this.actions.fetchGrupos()

    } catch (error) {
      console.error("Error eliminando grupo", error)
    }
  }

}